interface MetricCardProps {
    icon: string;
    label: string;
    value: string | number;
    bgColor?: string;
}

export default function MetricCard({
    icon,
    label,
    value,
    bgColor = "bg-blue-100"
}: MetricCardProps) {
    return (
        <div className="bg-white rounded-lg shadow p-2">
            <div className="flex items-center">
                <div className={`w-12 h-12 ${bgColor} rounded-lg flex items-center justify-center`}>
                    <span className="text-2xl">{icon}</span>
                </div>
                <div className="ml-4">
                    <p className="text-sm font-medium text-gray-600">{label}</p>
                    <p className="text-2xl font-semibold text-gray-900">{value}</p>
                </div>
            </div>
        </div>
    );
} 